import { combineReducers } from 'redux'
import UserReducer from "./UserReducer";
import OrderReducer from "./OrderReducer";
import WalletReducer from "./WalletReducer";
import ProfileReducer from "./ProfileReducer";
import FilterReducer from "./FilterReducer";



export default combineReducers({
    UserReducer,
    OrderReducer,
    WalletReducer,
    ProfileReducer,
    FilterReducer
})
